enum IndustryCategory {
  hotel = 'hotel',
  retail = 'retail',
  restaurant = 'restaurant'
}

export default IndustryCategory;
